import React, { memo, useState } from "react";
import {
	Row, Col,
	Card, CardBody,
	Button,
	Modal, ModalBody, ModalFooter
} from "reactstrap";

import Details from "components/FullTest/MockOperations/SpeakingWritingDirectory/Details";
import SelfIntro from "components/FullTest/MockOperations/SpeakingWritingDirectory/SelfIntro";
import Questions from "components/FullTest/MockOperations/Questions";

const SpeakingAndWriting = memo( function SpeakingAndWriting({
	mockData, questions, setSection, pending
}) {

	// Flag: 1 => Section Deatils.
	// Flag: 2 => Self Intro.
	// Flag: 3 => Questions.
	const [flag, setFlag] = useState(pending === 1 ? 3 : 1);
	const [startFlag, setStartFlag] = useState(false);
	const [currQ, setCurrQ] = useState(-1);

	const nextButton = (e) => {
		if (flag === 2) {
			setStartFlag(true);
		} else {
			setFlag(prev => (prev + 1));
			setCurrQ(0);
		}
	};

	const sectionTime = () => {
		return pending ? mockData.time : (parseInt(mockData.mock.speaking_time) + parseInt(mockData.mock.writting_time));
	};

	const toggleYes = () => {
		setStartFlag(prev => !prev);
		setFlag(prev => (prev + 1));
	};

	return (
		<>
			{(flag === 1 || flag === 2) &&
				<div className="content questionsArea deviceTestPage">
					<Row>
						<Col xs={12}>
							<Card>
								<CardBody>
									{flag === 1 &&
										<Details
											user={mockData.user_data}
											totalQuestions={questions.length}
											time={(parseInt(mockData.mock.speaking_time) + parseInt(mockData.mock.writting_time))}
										/>
									}

									{flag === 2 &&
										<SelfIntro />
									}
								</CardBody>
							</Card>
						</Col>

						<Col xs={12}>
							<div className="bottomBtns">
								<Row>
									<Col xs={9}>
										
									</Col>
									<Col xs={3}>
										<Button
											color="primary"
											onClick={nextButton}
											size="xs"
										>NEXT</Button>
									</Col>
								</Row>
							</div>
						</Col>
					</Row>
				</div>
			}

			{flag === 3 &&
				<Questions
					mockData={mockData}
					mock={mockData.mock}
					time={sectionTime()}
					questions={questions}
					setSection={setSection}
					pending={pending}
					skip={1}
				/>
			}

			<Modal isOpen={startFlag} size="sm">
				<ModalBody>
					<div>Do you want to go to next Question?</div>
				</ModalBody>

				<ModalFooter>
					<Button
						color="secondary"
						className="modalCloseBtn"
						onClick={toggleYes}
					>Yes</Button>

					<Button
						color="secondary"
						className="modalCloseBtn"
						onClick={() => setStartFlag(prev => !prev)}
					>No</Button>
				</ModalFooter>
			</Modal>
		</>		
	);
});

export default SpeakingAndWriting;